<template>
  <b-container
    style="position: relative ;"
  >
    <span
      class="mr-2"
      style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); display: inline-block;"
    >
      <div style="position: relative; width: 5rem; height: 5rem; margin: 0 auto;">
        <b-spinner
          style="width: 5rem; height: 5rem;"
          variant="primary"
          label="Spinning"
          class="text-center"
        ></b-spinner>
        <b-img
          style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -60%)"
          height="45"
          width="45"
          :src="require('@/assets/images/icons/cleaning-blue2.svg')"
          class="opacity-animation"
        ></b-img>
        <b-img
          style="position: absolute; top: 31%; left: 29%; transform: translate(-50%, -60%)"
          height="35"
          width="35"
          :src="require('@/assets/images/icons/cleaning-blue3.svg')"
          class="rotate-animation"
        ></b-img>
      </div>

      <p v-if="text" class="mt-3 mb-0 text-center text-grey">{{ text }}</p>

      <div v-if="cancel" class="text-center">
        <b-button
          variant="outline-secondary"
          size="sm"
          class="mt-2"
          @click="$emit('onCancel')"
        >
          {{ $t('button.go_back') }}
        </b-button>
      </div>
    </span>

  </b-container>
</template>
<script>
export default {
  name: 'LoadingSpinner',
  props: {
    text: {
      type: String,
      default: '',
    },
    cancel: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
<style scoped lang="scss">
.rotate-animation {
  animation: rotate-animation 1s linear infinite alternate;
}

@keyframes rotate-animation {
  50% {
    transform: rotate(10deg);
  }
  0%,
  100% {
    transform: rotate(-10deg);
  }
}

.opacity-animation {
  animation: opacity-animation 1.5s linear infinite alternate;
}

@keyframes opacity-animation {
  50% {
    opacity: 0;
  }
  0%,
  100% {
    opacity: 1;
  }
}

.spinner-border {
  animation: 1.25s linear infinite spinner-border !important;
  border: 0.13em solid currentcolor !important;
  border-right-color: transparent !important;
  color: #005dff75 !important;
}
</style>